import React from 'react';

export const PlaygroundDateMessage = ({ date }) => {
  return (
    <li className={'text-xs text-ebony_opacity_30 flex justify-center'}>
      <span>{date}</span>
    </li>
  );
};
